export default "__VITE_ASSET__CHUNVYvr__"